import { getPresenceCloudConfig } from '../config/cloudConfig';

let upsBaseUrl: string;
let _lazyIsInitialized = false;

const initializeBaseUrl = () => {
    upsBaseUrl = getPresenceCloudConfig().upsBaseUrl;
};

export function getUPSBaseUrl(): string {
    if (!_lazyIsInitialized) {
        initializeBaseUrl();
        _lazyIsInitialized = true;
    }
    return upsBaseUrl;
}

export function setUPSBaseUrl(url: string): void {
    upsBaseUrl = url;
}
